<template>
    <div>
        <div class="py-2">
            <b-card bg-variant="info" class="text-light p-3 mb-3" no-body>
                <template v-if="$i18n.locale === 'ko'">
                    <ul class="pl-3 mb-0">
                        <li class="f-100 mb-0"> 동일 기업 및 계정으로 이미 아래와 같이 평가 신청 내역이 있습니다.
                        </li>
                        <li v-show="duplicated_message.access_status === 0"
                            class="f-100 mb-0"> 로그인 후 평가에 참여주세요.
                        </li>
                        <li v-show="duplicated_message.access_status === 1"
                            class="f-100 mb-0"> 기업 평가 관리자의 <b class="text-underline">접근
                            승인</b>이 필요합니다.
                        </li>
                        <li v-show="duplicated_message.access_status === 2"
                            class="f-100 mb-0"> 기업 평가 관리자가 <b class="text-underline">참여
                            거부</b> 하였습니다. 아래 <b>"재신청하기" 버튼</b> 을 눌러 재신청 해주시거나 이메일을
                            참고해주세요.
                        </li>
                    </ul>
                </template>
                <template v-else>
                    <ul class="pl-3 mb-0">
                        <li class="f-100 mb-0">
                            {{ $t('동일 기업 및 계정으로 이미 아래와 같이 평가 신청 내역이 있습니다.') }}
                        </li>
                        <li v-show="duplicated_message.access_status === 0"
                            class="f-100 mb-0"> {{ $t('로그인 후 평가에 참여주세요.') }}
                        </li>
                        <li v-show="duplicated_message.access_status === 1"
                            class="f-100 mb-0"> {{ $t('기업 평가 관리자의 접근 승인이 필요합니다.') }}
                        </li>
                        <li v-show="duplicated_message.access_status === 2"
                            class="f-100 mb-0">
                            {{ $t('기업 평가 관리자가 참여 거부하였습니다. 아래 "재신청하기" 버튼을 눌러 재신청하시거나 이메일을 참고해주세요.') }}
                        </li>
                    </ul>
                </template>
            </b-card>

            <b-card class="bgray-100 mb-45">
                <b-row>
                    <b-col cols="6" lg="4" class="mb-2">
                        <p class="f-95 mb-1">{{ $t('기업명') }}</p>
                        <h6 class="f-105">{{ duplicated_message.company_name }}</h6>
                    </b-col>
                    <b-col cols="6" lg="4" class="mb-2">
                        <p class="f-95 mb-1">{{ $t('계정 email (ID)') }}</p>
                        <h6 class="f-105">{{ duplicated_message.email }}</h6>
                    </b-col>
                    <b-col cols="6" lg="4">
                        <p class="f-95 mb-1">{{ $t('평가 신청일') }}</p>
                        <h6 class="f-105 mb-0">{{ create_date_label }}</h6>
                    </b-col>
                    <b-col cols="6" lg="4">
                        <p class="f-95 mb-1">{{ $t('평가 참여가능 상태') }}</p>
                        <h6 class="f-105 mb-0">{{
                                $t(access_status_mapping[duplicated_message.access_status])
                            }}</h6>
                    </b-col>
                    <b-col cols="6" lg="4">
                        <p class="f-95 mb-1">{{ $t('참여 권한') }}</p>
                        <h6 class="f-105 mb-0">{{
                                duplicated_message.role === 1 ? $t("기업 일반 참여자") : $t("기업 평가 관리자")
                            }}</h6>
                    </b-col>
                </b-row>
            </b-card>
        </div>

        <!--        -->
        <template v-if="is_success_reapply !== null && duplicated_message.access_status === 2">
            <b-card v-if="is_success_reapply === true"
                    bg-variant="light" border-variant="success" no-body class="my-2 p-3">
                <div v-if="$i18n.locale === 'ko'">
                    감사합니다. 평가 관리자에게 평가 재신청 메일을 보냈고, 평가참여 승인시 이메일로 알려드리겠습니다.
                </div>
                <div v-else-if="$i18n.locale === 'en'">
                    Thank you. An email has been sent to the evaluation manager to reapply
                    for the evaluation, and you will be notified by email once the
                    participation is approved.
                </div>
                <div v-else>
                    谢谢。已向评估管理员发送重新申请评估的邮件，评估参与批准后我们会通过邮件通知您。
                </div>
            </b-card>

            <b-card v-else-if="is_success_reapply === false"
                    bg-variant="warning" no-body class="my-2 p-3">
                <p v-if="$i18n.locale === 'ko'" class="mb-0">
                    죄송합니다. 평가 재신청 도중 장애가 발생했습니다. 잠시후 다시 신청해주세요.
                </p>
                <p v-else-if="$i18n.locale === 'en'" class="mb-0">
                    We apologize, but an issue occurred during the reapplication process.
                    Please try again in a moment.
                </p>
                <p v-else class="mb-0">
                    抱歉，重新申请评估时出现问题。请稍后再试。
                </p>
            </b-card>
        </template>

        <CommonRegisterFooter>
            <template v-if="duplicated_message.access_status === 0">
                <b-btn variant="secondary"
                       :to="{ name: 'Login' }"
                       :disabled="calcLoading"
                >
                    {{ $t(`로그인`) }}
                </b-btn>
            </template>
            <template v-if="duplicated_message.access_status === 1">
                <b-btn variant="secondary"
                       class="ml-2"
                       :to="{ name: 'Login' }"
                       :disabled="calcLoading"
                >
                    {{ $t(`나가기`) }}
                </b-btn>
            </template>
            <template v-if="duplicated_message.access_status === 2">
                <b-btn variant="secondary"
                       class="ml-2"
                       :disabled="calcLoading || is_success_reapply === true"
                       @click="reapplyParticipation"
                >
                    <b-spinner v-if="calcLoading" small class="mr-1" />
                    {{ is_success_reapply === true ? $t(`재신청 완료`) : $t(`재신청하기`) }}
                </b-btn>
            </template>
        </CommonRegisterFooter>

    </div>
</template>

<script>
import CommonRegisterFooter from '@/components/auth/Register/_SubComponents/CommonRegisterFooter.vue';
import dayjs from 'dayjs';
import {mapActions, mapState} from 'vuex';
import {access_status_mapping} from '@/components/auth/Register/_SubComponents/data';

export default {
    name: 'DuplicatedRequestInfo',
    components: {CommonRegisterFooter},
    data() {
        return {
            is_success_reapply: null,
        };
    },
    computed: {
        ...mapState('register', ['register_loading', 'selected_vendor', 'duplicated']),
        duplicated_message() {
            return this.duplicated?.message || {};
        },
        access_status_mapping() {
            return access_status_mapping;
        },
        // 서버 원본 시각을 화면 언어에 맞춰 표시한다(Step 1 업체 선택과 같은 규칙) — 언어를 바꾸면 따라 바뀐다
        create_date_label() {
            const date = this.duplicated_message.create_date;
            if (!date) return '-';
            return this.$i18n.locale === 'ko'
                ? dayjs(date).locale('ko').format('YYYY년 M월 D일 HH:mm:ss')
                : dayjs(date).locale('en').format('DD/MM/YYYY ddd HH:mm:ss');
        },
        calcLoading() {
            return this.register_loading;
        },
    },
    methods: {
        ...mapActions('register', ['setRegisterLoading']),
        async reapplyParticipation() {
            if (this.register_loading || !this.duplicated?.email || !this.selected_vendor) return;

            this.setRegisterLoading(true);
            this.is_success_reapply = null;
            try {
                await this.$axios.post('/register/reapply', {
                    project_code: this.selected_vendor.project_code,
                    vendor_code: this.selected_vendor.vendor_code,
                    user_mail: this.duplicated.email,
                });
                this.is_success_reapply = true;
            } catch (error) {
                this.is_success_reapply = false;
            } finally {
                this.setRegisterLoading(false);
            }
        },
    },
};
</script>

<style lang="scss" scoped>

</style>
